import { obtenerCursoActivo } from './curso.js';

export function convertirHoras(listaHoras) {
	const mapaDias = {
		1: 'L',
		2: 'M',
		3: 'X',
		4: 'J',
		5: 'V',
	};
	if (! listaHoras) {
		// FIXME
		//return '-';
		return [];
	}
	//if not isinstance(lista_horas, list):
	//	lista_horas = [lista_horas]

	const dias = {};
	for (const h of listaHoras) {
		const componentesHoras = h.split('-');
		const numDia = componentesHoras[0];
		const horaInicio = componentesHoras[1];
		if (! dias[horaInicio]) {
			dias[horaInicio] = [];
		}
		dias[horaInicio].push(numDia);
	}

	const textos = []
	for (const h of Object.keys(dias)) {
		const htxt = h.substr(0, 2) + ':' + h.substr(2, 2);
		dias[h].sort();
		const diasTxt = dias[h].map((x) => mapaDias[x]);
		const txt = diasTxt.join(', ') + ' ' + htxt;
		textos.push(txt);
	}
	return textos;
}

export function convertirNiveles(listaNiveles) {
	const nivelesCurso = obtenerCursoActivo().niveles;
	// FIXME: This should be in a separate method
	const nivelesPorId = {};
	for (const n of nivelesCurso) {
		nivelesPorId[n.id_nivel] = n;
	}
	const nivelesTexto = []
	if (! Array.isArray(listaNiveles)) {
		listaNiveles = [listaNiveles];
	}
	for (const n of listaNiveles) {
		const texto = nivelesPorId[n].nombre;
		nivelesTexto.push(texto);
	}
	return nivelesTexto;
}

export function convertirNivelClase(nivelPersona) {
	const nivelesCurso = obtenerCursoActivo().niveles;
	// FIXME: This should be in a separate method
	const nivelesPorId = {};
	for (const n of nivelesCurso) {
		nivelesPorId[n.id_nivel] = n;
	}
	const nivel = nivelesPorId[nivelPersona.id_nivel];
	let texto = nivel.nombre;
	if (nivelPersona.clase) {
		texto += ' ' + nivelPersona.clase;
	}
	return texto;
}


export function convertirPeriodo(idPeriodo) {
	const periodosCurso = obtenerCursoActivo().periodos;
	// FIXME: This should be in a separate method
	const periodosPorId = {};
	for (const p of periodosCurso) {
		periodosPorId[p.id_periodo] = p;
	}
	return periodosPorId[idPeriodo].nombre;
}

/*
export function convertirNivelesRangos(listaNiveles) {
	FIXME: pendiente de migrar (casi todo Python)
	const gruposNiveles = [];
	const nivelesCurso = obtenerCursoActivo().niveles;
	let inicio = null;
	let seccion = null;
	let siguienteNivel = null;
	for (const n of listaNiveles) {
        # FIXME: aquí paré
		if (n.seccion == seccion and n['id'] == siguiente_nivel:
			fin = n['nombre']
			siguiente_nivel = n['siguiente']
		else:
			if inicio:
				grupos_niveles.append([inicio, fin])
			inicio = n['nombre']
			fin = n['nombre']
			seccion = n['seccion']
			siguiente_nivel = n['siguiente']
	grupos_niveles.append([inicio, fin])

	niveles_texto = []
	for inicio, fin in grupos_niveles:
		inicio = inicio.replace(' ', '&nbsp;');
		fin = fin.replace(' ', '&nbsp;');
		if inicio == fin:
			niveles_texto.append(inicio)
		else:
			niveles_texto.append('{0}<br />↓<br />{1}'.format(inicio, fin))
	return '<br />'.join(niveles_texto)
}
*/
